import OCWidgetPage from "./OCWidgetPage";

const DesignInspirePage = () => (
  <OCWidgetPage
    title="Design & Inspire Style Boards"
    description="Explore curated shingle and color pairings to find the perfect aesthetic for your home."
    metaDescription="Explore curated Owens Corning shingle color pairings and design inspiration for your home's exterior."
  >
    <div slide-delay="10000" className="oc_design_and_inspire" />
  </OCWidgetPage>
);

export default DesignInspirePage;
